/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Streaming platform
 * @export
 */
export const StreamingPlatform = {
    TWITCH: 'TWITCH',
    KICK: 'KICK',
    YOUTUBE: 'YOUTUBE',
    MULTI: 'MULTI'
} as const;
export type StreamingPlatform = typeof StreamingPlatform[keyof typeof StreamingPlatform];


export function instanceOfStreamingPlatform(value: any): boolean {
    for (const key in StreamingPlatform) {
        if (Object.prototype.hasOwnProperty.call(StreamingPlatform, key)) {
            if (StreamingPlatform[key as keyof typeof StreamingPlatform] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StreamingPlatformFromJSON(json: any): StreamingPlatform {
    return StreamingPlatformFromJSONTyped(json, false);
}

export function StreamingPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreamingPlatform {
    return json as StreamingPlatform;
}

export function StreamingPlatformToJSON(value?: StreamingPlatform | null): any {
    return value as any;
}

export function StreamingPlatformToJSONTyped(value: any, ignoreDiscriminator: boolean): StreamingPlatform {
    return value as StreamingPlatform;
}

